// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stress-check-panel {
    position: fixed;
    right: 0;
    top: 0;
    width: 320px;
    height: 100%;
    background-color: #fff;
    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
    z-index: 350;
    display: flex;
    flex-direction: column;
    transition: transform 0.3s ease;
}

.stress-check-header {
    padding: 20px;
    background-color: #f5f5f5;
    border-bottom: 1px solid #e0e0e0;
}

.stress-check-header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
}

.stress-check-list {
    flex: 1;
    overflow-y: auto;
    padding: 10px;
}

.stress-check-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    margin-bottom: 8px;
    background-color: #f9f9f9;
    border-radius: 8px;
    transition: background-color 0.2s;
}

.stress-check-item:hover {
    background-color: #f0f0f0;
}

.participant-name {
    font-size: 14px;
    font-weight: 500;
    color: #333;
}

.stress-icon {
    font-size: 24px;
}

.stress-check-legend {
    margin-top: 16px;
    padding: 12px;
    border-top: 1px solid #444;
    background-color: #2a2a2a;
    border-radius: 6px;
}

.stress-check-legend h4 {
    margin: 0 0 8px 0;
    font-size: 14px;
    color: #fff;
}

.legend-items {
    display: flex;
    flex-direction: column; /* 縦一列に変更 */
    gap: 6px; /* 間隔を少し狭く */
}

.legend-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    background-color: #3a3a3a;
    border-radius: 4px;
}

.legend-icon {
    font-size: 16px;
    min-width: 20px; /* アイコンの幅を統一 */
}

.legend-label {
    font-size: 12px;
    color: #e0e0e0;
}

.polling-indicator {
    font-size: 12px;
    color: #4CAF50;
    margin-top: 4px;
}

.error-indicator {
    font-size: 12px;
    color: #f44336;
    margin-top: 4px;
}

.last-updated {
    font-size: 10px;
    color: #888;
    margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./react/features/stress_check/components/web/stress-check-panel.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,MAAM;IACN,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,0CAA0C;IAC1C,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB,EAAE,WAAW;IACnC,QAAQ,EAAE,YAAY;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe,EAAE,cAAc;AACnC;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;AACnB","sourcesContent":[".stress-check-panel {\n    position: fixed;\n    right: 0;\n    top: 0;\n    width: 320px;\n    height: 100%;\n    background-color: #fff;\n    box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);\n    z-index: 350;\n    display: flex;\n    flex-direction: column;\n    transition: transform 0.3s ease;\n}\n\n.stress-check-header {\n    padding: 20px;\n    background-color: #f5f5f5;\n    border-bottom: 1px solid #e0e0e0;\n}\n\n.stress-check-header h3 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n}\n\n.stress-check-list {\n    flex: 1;\n    overflow-y: auto;\n    padding: 10px;\n}\n\n.stress-check-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 16px;\n    margin-bottom: 8px;\n    background-color: #f9f9f9;\n    border-radius: 8px;\n    transition: background-color 0.2s;\n}\n\n.stress-check-item:hover {\n    background-color: #f0f0f0;\n}\n\n.participant-name {\n    font-size: 14px;\n    font-weight: 500;\n    color: #333;\n}\n\n.stress-icon {\n    font-size: 24px;\n}\n\n.stress-check-legend {\n    margin-top: 16px;\n    padding: 12px;\n    border-top: 1px solid #444;\n    background-color: #2a2a2a;\n    border-radius: 6px;\n}\n\n.stress-check-legend h4 {\n    margin: 0 0 8px 0;\n    font-size: 14px;\n    color: #fff;\n}\n\n.legend-items {\n    display: flex;\n    flex-direction: column; /* 縦一列に変更 */\n    gap: 6px; /* 間隔を少し狭く */\n}\n\n.legend-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px 10px;\n    background-color: #3a3a3a;\n    border-radius: 4px;\n}\n\n.legend-icon {\n    font-size: 16px;\n    min-width: 20px; /* アイコンの幅を統一 */\n}\n\n.legend-label {\n    font-size: 12px;\n    color: #e0e0e0;\n}\n\n.polling-indicator {\n    font-size: 12px;\n    color: #4CAF50;\n    margin-top: 4px;\n}\n\n.error-indicator {\n    font-size: 12px;\n    color: #f44336;\n    margin-top: 4px;\n}\n\n.last-updated {\n    font-size: 10px;\n    color: #888;\n    margin-top: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
